import { enUS, ja } from 'date-fns/locale'
import i18n from '../../i18n'
import { Locale } from 'date-fns'

const locales: { [key in 'ja' | 'en']: Locale } = { ja, en: enUS }
const getDateLocale: () => Locale = () => locales[i18n.language as 'ja' | 'en']

export default getDateLocale
